import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
// import axios from 'axios'
import * as _ from 'lodash';
// import consts from '@/common/consts'
import vehicleApi from '@/api/vehicleApi';
import moment from 'moment';
var state = {
  // 车辆列表
  vehicleList: [],
  vehicleListParams: []
};
var mutations = {
  VEHICLE_LIST: function VEHICLE_LIST(state, data) {
    state.vehicleList = data;
  },
  VEHICLELIST_PARAMS: function VEHICLELIST_PARAMS(state, data) {
    state.vehicleListParams = data;
  }
};
var actions = {
  loadVehicleList: function () {
    var _loadVehicleList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, params) {
      var commit, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            commit('VEHICLELIST_PARAMS', params);
            _context.prev = 2;
            _context.next = 5;
            return vehicleApi.getVehicleList(params);
          case 5:
            lostResp = _context.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context.next = 12;
              break;
            }
            commit('VEHICLE_LIST', data);
            return _context.abrupt("return", lostResp);
          case 12:
            commit('VEHICLE_LIST', []);
            return _context.abrupt("return", Promise.reject(message));
          case 14:
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", Promise.reject('异常：' + _context.t0));
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 16]]);
    }));
    function loadVehicleList(_x, _x2) {
      return _loadVehicleList.apply(this, arguments);
    }
    return loadVehicleList;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};